import { useConfig } from '@/hooks/config';
import { Accordion, AccordionItem } from '@heroui/react';
import type { ReactNode } from 'react';

export function Debug({
  value,
  collapse,
  compact = true,
}: {
  value: unknown;
  collapse?: boolean;
  compact?: boolean;
}) {
  const config = useConfig();
  if (!config.debug) {
    return null;
  }

  if (value instanceof Object) {
    value = JSON.stringify(value, null, 2);
  }

  const Content = ({ children }: { children: ReactNode }) => {
    return !collapse ? (
      children
    ) : (
      <Accordion variant='light' className='font-sans'>
        <AccordionItem key='1' aria-label='debug' title='Debug'>
          {children}
        </AccordionItem>
      </Accordion>
    );
  };

  return (
    <Content>
      <div
        className={`whitespace-pre rounded-medium bg-yellow-200 p-4 font-mono text-xs ${compact ? 'max-h-40 overflow-y-auto' : ''}`}
      >
        {String(value)}
      </div>
    </Content>
  );
}
